import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import styled, { css, withTheme } from 'styled-components'
import { Flex, FlexColumn } from '../../../../Reusable/Container'
import hexToRgba from 'hex-to-rgba';

import AI from '../../../../../Images/AI.svg'
import { InitialCircle } from '../../../../Reusable/InitialCircle';
import { getDateInLocalTZ, getLogoFromDomain, toCurrency } from '../../../../../Utils/util';
import { Divider } from '../../../../Reusable/Divider';
import { LucideCalendarDays, LucideCheckCheck, LucideCheckCircle, LucideMessageSquareWarning } from 'lucide-react';
import { Image } from '../../../../Reusable/Image';
import { Tag, TagV2, Text } from '../../../../Reusable/Text'
import moment from 'moment'
import { connect } from 'react-redux'
import VendorCard from './VendorCard';
import { apiPOSTReq } from '../../../../../Utils/api';
import environment from '../../../../../environment';
import { ApprovalGraph } from '../../../../Reusable/Approval';
import { CardContainer } from './CardContainer';
import ExpenseCategorizationSummary from './ExpenseCategorizationSummary';
import PaymentHistory from './PaymentHistory';
import { AmtDecimalSubscript } from '../../../../Reusable/AmountLabel';
import Banner from '../../../../Reusable/Banner';
import BoldBanner from '../../../../Reusable/BoldBanner';

class BillSummary extends Component {
    state = {
        bill: this.props.bill,
        vendor: this.props.vendor,
        expenseCategorizationRequired: false
    }

    componentDidMount() {
        this.evaluatePaymentApproval(this.state.bill?.balance);
    }

    componentDidUpdate(prevProps) {
        // Check if view mode has changed, refetch payments
        if (this.props.viewMode !== prevProps.viewMode) {
            this.setState({ bill: this.props.bill });
        }

        if(this.props.bill !== prevProps.bill) {
            this.setState({ bill: this.props.bill });
            this.evaluatePaymentApproval(this.state.bill?.balance);
        }

        if(this.props.vendor !== prevProps.vendor) {
            this.setState({ vendor: this.props.vendor });
        }

    }

    evaluatePaymentApproval = (amt) => {
        const { vendor } = this.state

        const body = {
            paymentAmount: amt,
            vendorName: vendor?.vendorName,
        }

        apiPOSTReq(`${environment.payBaseUrl}/payables/evaluatePaymentApproval`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    this.setState({ approvalRequired: data.approvalRequired, approvalRule: data.approvalRule })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR /payables/evaluatePaymentApproval", error, err, resp)
                /* ErrorAlert({ description: error.message }) */
            }
        })
    }

    render() {
        var { bill, vendor, approvalRequired, approvalRule, expenseCategorizationRequired } = this.state;
        var { theme, scheduledPayments, viewMode, convertedBillInbox } = this.props;
        var { invoiceNumber, amount, status, dueDate } = bill || {};
        
        var billAmt = toCurrency(amount);

        return (
            <FlexColumn gap='24px'>
                <Flex start centerHorizontally gap='16px'>
                    <Image src={AI} />
                    <Text>Our AI Engine automatically captured important details from your bill. Feel free to modify as needed.</Text>
                    
                </Flex>
                
                {
                    convertedBillInbox &&
                    <BoldBanner
                        message="Successfully converted to a bill. Pay now or view later in the Drafts tab."
                        background={hexToRgba(theme.colors.primary9, 0.1)}
                        color={hexToRgba(theme.colors.primary9, 1)}
                        icon={<LucideCheckCircle color={hexToRgba(theme.colors.primary9, 1)} />}
                    />
                }

                {
                    (!vendor?.id || expenseCategorizationRequired) &&
                    <>
                        <Flex start centerH gap='8px'>
                        <LucideMessageSquareWarning size='20px' color={hexToRgba(theme.colors.primary6, 1)} />
                            <Text height='14px' weight={500}>Your input is required to process this bill</Text>
                        </Flex>
                    </>
                }
                

                <CardContainer padding='36px' gap='16px' start gradientBorder={viewMode}>
                    
                    <Text light size='14px'>Bill #{invoiceNumber}</Text>
                    {/* Vendor Info */}
                    <VendorCard 
                        vendor={vendor} 
                        bill={bill} 
                        loadStep={this.props.loadStep}
                    />

                    <Divider margin='4px 0px' />

                    {/* Bill info */}
                    <Flex between>
                        <FlexColumn left gap='4px'>
                            <Text light size='14px'>Due</Text>
                            <Text size='24px' weight={600} height='32px'>{dueDate ? moment(dueDate).format("MMM D, YYYY") : "N/A"}</Text>
                            {
                                dueDate && 
                                <Flex centerH gap='8px'>
                                    <LucideCalendarDays size='16px' color={theme.colors.defaultLightText} /><Text light size='14px'>{`${moment(dueDate).diff(moment(), 'days') > 0 ? 'Due in' : 'Overdue by'} ${Math.abs(moment(dueDate).diff(moment(), 'days'))} days`}</Text>
                                </Flex>
                            }
                        </FlexColumn>
                        <FlexColumn right gap='4px'>
                            <Text light size='14px'>Bill Amount</Text>
                            <AmtDecimalSubscript amt={"$"+billAmt} />
                            {
                                status !== "Paid" ?
                                <Tag size='12px' radius='12px' padding='4px 10px'>{status}</Tag>
                                :
                                <TagV2 centerH gap='4px'>
                                    <LucideCheckCheck size={16} color={theme.colors.primary9} />
                                    {status}
                                </TagV2>
                            }
                        </FlexColumn>
                    </Flex>

                    {/* Payment history */}
                    <PaymentHistory 
                        bill={bill}
                        scheduledPayments={scheduledPayments}
                        getSchldPmts={this.props.getSchldPmts}
                        billAmtPaid={this.props.billAmtPaid}
                        getBill={this.props.getBill}
                        updateBillVendor={this.updateBillVendor}
                        viewMode={viewMode}
                    />

                    <Divider margin='4px 0px' />

                    <ExpenseCategorizationSummary 
                        bill={bill}
                        onEdit={() => this.props.loadStep("EditExpenseCategorization")}
                        expenseCategorizationRequired={(req) => {
                            this.props.expenseCategorizationRequired(req);
                            this.setState({ expenseCategorizationRequired: expenseCategorizationRequired });
                        }}
                    />

                    {
                        viewMode && approvalRequired && 
                        <>
                            <Divider margin='4px 0px' />
                            <Flex start between centerH>
                                <Text size='16px' weight={600}>Approvals required</Text>
                                <ApprovalGraph margin='0px' miniVersion rule={approvalRule} />
                            </Flex>
                        </>
                    }
                </CardContainer>
            </FlexColumn>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(BillSummary)))